
import { Chat } from "@/components/Chat";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Helmet } from "react-helmet";
import { Component, Product } from "@/lib/session";

const Index = () => {
  const [ogImage, setOgImage] = useState("/og-image.png");
  const [ogTitle, setOgTitle] = useState("CarQuest - Your Automotive Assistant");
  const [ogDescription, setOgDescription] = useState("Find the perfect car parts and accessories with our AI-powered assistant.");

  useEffect(() => {
    const updateMetaTags = async () => {
      const sessionId = localStorage.getItem('sessionId') || new URLSearchParams(window.location.search).get('sessionId');
      
      if (sessionId) {
        const { data: messages } = await supabase
          .from('messages')
          .select('components')
          .eq('session_id', sessionId)
          .order('created_at', { ascending: false })
          .limit(1);

        if (messages && messages.length > 0 && messages[0].components) {
          const components = messages[0].components as unknown as Component[];
          const productComponent = components.find(c => 
            c.type === 'product-card' && c.props?.product?.imageUrl
          );
          
          if (productComponent?.props?.product) {
            const product = productComponent.props.product as Product;
            setOgImage(product.imageUrl);
            setOgTitle(`CarQuest - ${product.name}`);
            setOgDescription(product.description);
          }
        }
      }
    };

    updateMetaTags();
  }, []);

  const baseUrl = 'https://carquest.ai';
  const absoluteImageUrl = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

  return (
    <>
      <Helmet>
        <title>{ogTitle}</title>
        <meta name="description" content={ogDescription} />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:image" content={absoluteImageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={baseUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={ogDescription} />
        <meta name="twitter:image" content={absoluteImageUrl} />
      </Helmet>
      <main className="min-h-screen bg-background relative">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <svg width="100%" height="100%">
              <pattern
                id="carPattern"
                x="0"
                y="0"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
                className="text-primary/10"
              >
                <path
                  d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm-5 10l-5 10 5 10h10l5-10-5-10H15z"
                  fill="currentColor"
                />
              </pattern>
              <rect width="100%" height="100%" fill="url(#carPattern)" />
            </svg>
          </div>
          <div 
            className="absolute inset-0 bg-gradient-to-br from-white/90 via-blue-50/50 to-transparent"
            style={{ mixBlendMode: 'overlay' }}
          />
        </div>
        <div className="relative min-h-screen z-10">
          <Chat />
        </div>
      </main>
    </>
  );
};

export default Index;
